import { useState, useEffect } from 'react'
import getConfig from 'next/config'
import { USERINFO_STATUS } from '@ycos/constants'

const { publicRuntimeConfig } = getConfig() || {}

export const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState({ userInfo: null, userInfoStatus: USERINFO_STATUS.NOTLOADED })
  const isPreview = publicRuntimeConfig?.isPreview

  useEffect(() => {
    try {
      setUserInfo({ userInfo: null, userInfoStatus: USERINFO_STATUS.LOADING })
      if (isPreview && location.hash.includes('isEIP=true')) {
        setUserInfo({ userInfo: { id: 0, isEip: true, status: 'REMEMBERED', welcomePackSent: true }, userInfoStatus: USERINFO_STATUS.LOADED })
      } else {
        window.SF.getUserSummary?.().then((res) => {
          setUserInfo({ userInfo: res, userInfoStatus: USERINFO_STATUS.LOADED })
        })
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      setUserInfo({ userInfo: {}, userInfoStatus: USERINFO_STATUS.LOADED })
    }
  }, [])

  return userInfo
}
